import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { environment } from '../../../../environments/environment';

const ACCOUNT_QUOTA_SCHEMA = Object.freeze({
  USED: 0,
  DELETED: 0,
  CAN_CREATE: false,
  LIMIT: 0,
  TOTAL_USAGE: 0,
  REMAINING: 0,
});
const RECORD = generateSchema(ACCOUNT_QUOTA_SCHEMA);
const KEYS: any = generateKeys(ACCOUNT_QUOTA_SCHEMA);

export class AccountQuota extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get used(): number {
    return this.get(KEYS.USED);
  }

  get deleted(): number {
    return this.get(KEYS.DELETED);
  }

  get canCreate(): boolean {
    return environment.features.featureFramework
      ? this.get(KEYS.CAN_CREATE)
      : true;
  }

  get limit(): number {
    return this.get(KEYS.LIMIT);
  }

  get remaining(): number {
    return this.get(KEYS.REMAINING);
  }

  get totalUsage(): number {
    return this.get(KEYS.TOTAL_USAGE);
  }
}
